export const ADS_REPORT_KEYS = ["ad_views", "views_unique_users", "ad_opens", "ad_opens_unique_users"];
export const ADS_SEARCH_ONLY_KEYS = ["insights_display_name"];
